import React, { useState } from 'react'
import './index.scss'
import activeIcon from '../../assets/images/Checkmark.png'
export const SORTTYPE = [
    {
        label: '销量排序',
        value: 'sales'
    },
    {
        label: '折扣排序',
        value: 'discount'
    },
    {
        label: '价格升序',
        value: 'priceAscTag'
    },
    {
        label: '价格降序',
        value: 'priceDescTag'
    },
    {
        label: '默认排序',
        value: ''
    }
]
export interface IDefaultSortProps {
    setSearchQuery: (type: string, vlaue: any) => Promise<{}>
    q: any
    searchProducts: () => void
}

const DefaultSort = (props: IDefaultSortProps) => {
    const { setSearchQuery, q, searchProducts } = props
    const setDefault = value => {
        setSearchQuery('s', value).then(res => {
            searchProducts()
        })
    }
    return (
        <div className="defaultSort">
            {SORTTYPE.map((item, index) => {
                return (
                    <div
                        className={`defaultItem ${
                            q.s === item.value || (!q.s && !item.value)
                                ? 'active'
                                : ''
                        }`}
                        key={`default${index}`}
                        onClick={() => setDefault(item.value)}
                    >
                        <div className="labelText">{item.label}</div>
                        {q.s === item.value || (!q.s && !item.value) ? (
                            <img
                                className="activeIcon"
                                src={activeIcon}
                                alt=""
                            ></img>
                        ) : (
                            ''
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default DefaultSort
